import { requestWithToken } from '../utilities/request';
const path = '/api/private/ccus/field';

/**
 * CCUS現場取得開始API
 * @param {object} params
 * */
const beginFetchCcusFieldData = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: `${path}/begin_fetch`,
      params,
    },
    true,
    false
  );
};

/**
 * CCUS現場取得API
 * @param {object} params
 * */
const fetchCcusFieldData = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: `${path}/fetch`,
      params,
    },
    true,
    false
  );
};

/**
 * CCUS現場IDクリアAPI
 * @param {object} param
 * */
const clearCcusSiteId = param => {
  return requestWithToken(
    {
      method: 'PATCH',
      url: `${path}/clear_ccus_site_id`,
      data: param,
    },
    true,
    false
  );
};

/**
 * CCUS連携を停止するAPI
 * @param {object} param
 * */
const stopFieldConnectionStatus = param => {
  return requestWithToken(
    {
      method: 'PATCH',
      url: `${path}/stop_field_connection_status`,
      params: param,
    },
    true,
    false
  );
};

const cooperatFieldTreeWithCcus = (param) => {
  return requestWithToken({
    method: 'POST',
    url: path,
    params: param,
  });
};

const checkPermissionFieldTreeCooperationWithCcus = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/check_enable_ccus`,
    params: {
      field_id: fieldId,
    },
  });
};

export const FieldCcusApi = {
  beginFetchCcusFieldData,
  fetchCcusFieldData,
  clearCcusSiteId,
  stopFieldConnectionStatus,
  cooperatFieldTreeWithCcus,
  checkPermissionFieldTreeCooperationWithCcus,
};
export default FieldCcusApi;



// WEBPACK FOOTER //
// ./src/services/FieldCcus.js